// src/components/BrandlyChange.jsx
import React from "react";
import "./BrandlyChange.css";
import Icon1 from "../../assets/BrandlyChangeBox/Icon1.png";
import Icon2 from "../../assets/BrandlyChangeBox/Icon2.png";
import Icon3 from "../../assets/BrandlyChangeBox/Icon3.png";
import LeftFullPost from "../../assets/LandingPageGraphics/FullLeftPost.png";
import RightFullPost from "../../assets/LandingPageGraphics/FullRightPost.png";

const cards = [
  {
    icon: Icon1,
    title: "EASY",
    text: "AI writes content for you",
    capsule: "3X FASTER"
  },
  {
    icon: Icon2,
    title: "EFFICIENT",
    text: "Optimized for engagement",
    capsule: "5X GROWTH"
  },
  {
    icon: Icon3,
    title: "FOCUSED",
    text: "Targeted audience growth",
    capsule: "10X REACH"
  }
];

const BrandlyChange = () => {
  return (
    <div className="brandly-change-section">
      <h2 className="brandly-change-heading">
        <span className="blue-text">Brandly</span> Changes Everything
      </h2>
      <p className="brandly-subtext">
        AI-powered personal branding made simple
      </p>

      <img
              src={LeftFullPost}
              alt="Left Graphic"
              className="left-change-graphic"
              
            />
            <img
              src={RightFullPost}
              alt="Right Graphic"
              className="right-change-graphic"
              
            />
      <div className="brandly-card">
        {cards.map((card, index) => (
          <div className="brandly-box" key={index}>
            <img src={card.icon} alt={card.title} className="brandly-icon" />
            <h3 className="brandly-box-title">{card.title}</h3>
            <p className="brandly-box-text">{card.text}</p>
            <div className="brandly-capsule">
              <span className="brandly-capsule-text">{card.capsule}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BrandlyChange;
